import { ButtonHTMLAttributes } from "react";
import { useTranslation } from "react-i18next";
import NoDataImage from "../../assets/images/no-data.png";  
import * as S from "./styles";

interface NotFoundProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  title?: string;
  content: string;
  buttonTitle?: string;
  showImage?: boolean;  
}

export function NotFound({ title, content, buttonTitle, showImage = true, ...rest }: NotFoundProps) {
  const { t } = useTranslation();

  return (
    <S.Container>
      {showImage && <img src={NoDataImage} alt={t("noDataImageAlt")} />} 
      <h3>{title ? title : t("noDataFound")}</h3>
      <span>{content}</span>

      {buttonTitle && <button {...rest}>{buttonTitle}</button>}
    </S.Container>
  );
}
